export default __webpack_public_path__ + "static/media/step_03.5a2dd4f7.png";